import { render } from "./OfferingDrawer.vue?vue&type=template&id=20d234ca&scoped=true"
import script from "./OfferingDrawer.vue?vue&type=script&lang=js"
export * from "./OfferingDrawer.vue?vue&type=script&lang=js"

import "./OfferingDrawer.vue?vue&type=style&index=0&id=20d234ca&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20d234ca"]])

export default __exports__